import type { FC } from 'react';

import TextField from '../../../input_field/input_field';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'type',
  'placeholder',
  'autoFocus',
  'inputMode',
  'inputClassName',
  'onKeyDown',
  'hideInputError',
] as const;

const Field = formField(TextField, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type TextFieldWrapperProps = FieldWrapperProps<typeof Field>;

const TextFieldWrapper: FC<TextFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default TextFieldWrapper;
